import { HandlersCollection } from '@tblabs/truffle';
import { Translations } from '../Translations/Translations';
import { IServer } from './IServer';
import { Status } from './Status/Status';
import { IWatcher } from './IWatcher';


export class DemoWatcher implements IWatcher
{
    public OnKick = new HandlersCollection<(reason: string) => void>();
    public OnMessage = new HandlersCollection<(message: string) => void>();

    constructor(private _server: IServer, private _lang: Translations, private _status: Status) 
    { }

    public Init(): void 
    { }
}
